import designComment from '../models/design-comment';

export default {
    defaultProperties,
    fromJSON,
};

function defaultProperties() {
    return [];
}

// Translate from Contests HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    return json._embedded.comments.map(designComment.fromJSON);
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/models/design-comment-collection.js